import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "button"];

  connect() {}

  unckeckAll(event) {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false;
    });
    event.preventDefault();
  }
}
